<template>
  <div class="content">
    <!-- <div v-for="index in 12" :key="index" @click="clickSx(index)">
      <img :src="require(`../../../assets/sx/${index}.png`)" alt="" />
    </div> -->
    <div v-for="(item, index) in list" :key="index" @click="clickSx(item.id)">
      <img :src="item.icon" alt="" />
    </div>
    <shareBottomComp v-if="share == 1"></shareBottomComp>
  </div>
</template>

<script>
/**
@description:十二生肖
@createTime:2021-08-23
@create:wq
*/
import { shareJsSdk,HERF, getQueryString } from "@/utils/tool";
import shareBottomComp from "@/components/shareBottomComp";
export default {
  name: "",
  props: {},
  components: {shareBottomComp},
  data() {
    return {
      list: [],
      share:0
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    this.getDataList();
    if (getQueryString("share")) {
      this.share = 1;
    } else {
      this.share = 0;
    }
  },
  methods: {
    clickSx(id) {
      this.$router.push({ path: "/sxdetails", query: { id: id } });
    },
    getDataList() {
      this.api.fortuneList({ type: 2 }).then((res) => {
        this.list = res.data;
        shareJsSdk('sx','生肖运势详解');
      });
    },
  },
};
</script>

<style>
body {
  background: #eaf0f0;
}
</style>
<style lang="scss" scoped>
.content {
  display: flex;
  flex-wrap: wrap;
  > div {
    width: calc(100vw / 3);
    img {
      width: 100%;
    }
  }
}
</style>
